import React, { useRef, RefObject } from 'react';
import LayoutSettingsTabs from "components/QuotesLayoutSettings/LayoutSettingsTabs";
import {LayoutSideDropdown} from "./tabsLayoutDropdownStyles";
import { useClickOutside } from 'hooks/useClickOutside';

export interface IProps {
    isOpen: boolean
    ref: RefObject<HTMLDivElement>
    wrapperRef: RefObject<HTMLDivElement>
    closeHandler: () => void
}


const TabsLayoutDropdown = ({isOpen, ref, wrapperRef, closeHandler}: IProps) => {
    // const ref = useRef<HTMLDivElement>(null)

    useClickOutside(isOpen, ref, closeHandler)
    useClickOutside(isOpen, wrapperRef, closeHandler)

    return (
        <div ref={ref}>
            <LayoutSideDropdown  dropTitle={"Настройки вкладки"}>
                <LayoutSettingsTabs/>
            </LayoutSideDropdown>
        </div>
    );
};

export default TabsLayoutDropdown;
